// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"659cd063","973":"6b17090a"}[chunkId] + ".chunk.js";
};